import types from './types';
const reducer = (state, action) => {
  const newState = { ...state };

  switch (action.type) {
    case types.SET_IS_REPORT_LOADING:
      newState.isLoading = action.payload;
      break;
    case types.SET_RANGE_DAYS:
      newState.rangeStartDate = action.payload.startDate;
      newState.rangeEndDate = action.payload.endDate;
      newState.rangeOption = action.payload.rangeOption;
      break;
    case types.SET_USE_CASE_TYPE:
      newState.useCase = action.payload;
      break;
    case types.SET_OVERVIEW_DASHBOARD_FILTER:
      newState.useCaseOverviewDashboardFilter = action.payload || null;
      break;

    default:
      return newState;
  }

  return newState;
};

export default reducer;
